import { render, staticRenderFns } from "./wx.vue?vue&type=template&id=8b98786a&scoped=true&"
import script from "./wx.vue?vue&type=script&lang=js&"
export * from "./wx.vue?vue&type=script&lang=js&"
import style0 from "./wx.vue?vue&type=style&index=0&id=8b98786a&scoped=true&lang=css&"
import style1 from "./wx.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b98786a",
  null
  
)

export default component.exports